import { html, LitElement } from 'lit'
import { property, customElement } from 'lit/decorators.js'
import type * as yup from 'yup'
import type { WorkflowIconAttributes } from 'zaptic-workflow-icon'
import { assumeExhaustion, createStringEnum } from '../lib/typeHelpers.no-deps'
import { getIcon } from './helpers/icons'
import { oneOfStringsAttributeSchema } from './helpers/yup'
import style from './style/zaptic-workflow-item-style'

type Attributes = WorkflowIconAttributes

export const workflowIconTypes = createStringEnum('guide', 'task', 'training', 'action')
export const workflowIconModes = createStringEnum('active', 'passive', 'negative')
export type WorkflowIconType = (typeof workflowIconTypes)[0]
export type WorkflowIconMode = (typeof workflowIconModes)[0]

@customElement('zaptic-workflow-icon')
export class WorkflowIcon extends LitElement {
    static styles = style

    @property({ converter: (val) => typeSchema.validateSync(val) })
    private type: WorkflowIconType

    @property({ converter: (val) => modeSchema.validateSync(val) })
    private mode: WorkflowIconMode

    render() {
        return html`<div class="${this.type} ${this.mode}">${this.icon()}</div>`
    }

    private icon() {
        switch (this.type) {
            case 'guide':
                return null // Don't actually have an icon
            case 'task':
                return getIcon('task')
            case 'training':
                return getIcon('training')
            case 'action':
                return getIcon('lightning-hollow')
            default:
                assumeExhaustion(this.type)
                return null
        }
    }
}

const typeSchema = oneOfStringsAttributeSchema(...workflowIconTypes) as yup.Schema<Attributes['type']>
const modeSchema = oneOfStringsAttributeSchema(...workflowIconModes) as yup.Schema<Attributes['mode']>
